<template>
    <div>
        <div v-if="type_save">
            <b-form inline>
				<b-form-input placeholder="configuration" v-model="name"></b-form-input>
				<b-button v-b-modal="'modal' + id">Charger</b-button>
				<b-button @click="save_library" :disabled="!version || !name"><i class="fas fa-save"></i></b-button>
			</b-form>

			<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
				<span>Nom</span>
				<v-select v-model="load_name" :options="names"></v-select>
			</b-modal>
        </div>

        <div v-for="(param, idx) in params" :key="param.name">
            <div v-show="(!dashboard || param.dashboard) && (!only_visible || param.visible)">
                <span v-show="param.type.type != 'hidden'" v-b-tooltip.hover :title="param.description">{{param.libelle || param.name}}</span><b-button v-if="!param.required" variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
                <span v-if="edit_visible"> - Visible
                    <b-form-checkbox style="display:inline"
                        v-model="param.visible"
                        :value="true"
                        :unchecked-value="false"
                    />
                    
                </span>
                <div v-if="param.type.type == 'texte'">
                    <b-input :list="param.name" v-model="param.value" :type="param.type.html_type || 'text'"></b-input>
                    <datalist v-if="param.type.datalist && param.type.datalist.length > 0" :id="param.name">
                        <option v-for="(option, idx) in param.type.datalist" :key="idx">{{ option }}</option>
                    </datalist>
                </div>
                <div v-if="param.type.type == 'draggable'">
                    <draggable
                        group="step"
                        :list="param.value"
                        class="list-group">
                        <div class="list-group-item" v-for="(obj, idx_list) in param.value" :key="idx_list" style="background">
                            <b-input-group :prepend="'' + (idx_list + 1)">
                                <b-input :list="param.name + idx" v-model="obj.value" :type="'text'"></b-input>
                                <b-button @click="del_elem(idx, idx_list)" variant="danger"><i class="fas fa-trash"></i></b-button>
                            </b-input-group>
                            <datalist :id="param.name + idx">
                                <option v-for="(option, idx) in param.type.datalist" :key="idx">{{ option }}</option>
                            </datalist>
                        </div>
                    </draggable>
                    <b-button @click="new_elem(idx)"><i class="fas fa-plus"></i></b-button>
                    <br />
                </div>
                <div v-if="param.type.type == 'draggable_list'">
                    <draggable
                        group="step"
                        :list="param.value"
                        class="list-group">
                        <div class="list-group-item" v-for="(obj, idx_list) in param.value" :key="idx_list" style="background">
                            <b-input-group :prepend="'' + (idx_list + 1)">
                                <b-form-select v-model="obj.value" :options="param.type.options"></b-form-select>
                                <b-button @click="del_elem(idx, idx_list)" variant="danger"><i class="fas fa-trash"></i></b-button>
                            </b-input-group>
                        </div>
                    </draggable>
                    <b-button @click="new_elem(idx)"><i class="fas fa-plus"></i></b-button>
                    <br />
                </div>
                <div v-if="param.type.type == 'textarea'">
                    <b-textarea :rows="param.type.rows || 5" v-model="param.value"></b-textarea>
                </div>
                <div v-if="param.type.type == 'textarea_plus'">
                    <textarea_plus :ref="'params_' + idx" :columns="columns"></textarea_plus>
                </div>
                <div v-if="param.type.type == 'json_schema_editor'">
                    <json_schema_editor :ref="'params_' + idx" :columns="columns"></json_schema_editor>
                </div>
                <div v-if="param.type.type == 'null'">
                    Valeur vide
                </div>
                <div v-if="param.type.type == 'checkbox'">
                    <b-form-checkbox-group
                        :name="param.name + '_' + id + idx"
                        v-model="param.value"
                        :options="param.type.options"
                    ></b-form-checkbox-group>
                </div>
                <div v-if="param.type.type == 'radio'">
                    <b-form-radio inline v-for="(option, idx) in param.type.options" :key="idx" v-model="param.value" :name="param.name + '_' + id + idx" :value="option.value">{{ option.text }}</b-form-radio>
                </div>
                <div v-if="param.type.type == 'list'">
                    <b-form-select v-model="param.value" :options="param.type.options" :multiple="param.type.multiple"></b-form-select>
                </div>
                <div v-if="param.type.type == 'autocomplete'">
                    <vue-tags-input v-if="param.value"
                        :autocomplete-min-length="0"
                        placeholder="Ajouter"
                        v-model="val"
                        :tags="param.value"
                        :autocomplete-items="filteredItems(idx)"
                        @tags-changed="newOptions => param.value = newOptions"
                        style="max-width: 100%" />
                </div>
            </div>
        </div>
        <div v-if="optional_params.length > 0">
            <br />
            <div>Paramètres supplémentaires</div>
            <b-button variant="link" @click="add(idx)" v-b-tooltip.hover :title="param.description" v-for="(param, idx) in optional_params" :key="param.name">{{param.libelle || param.name}}</b-button>
        </div>
    </div>
</template>

<script>
	import VueTagsInput from "@johmun/vue-tags-input";
    import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";

    import json_schema_editor from '../components/json_schema_editor.vue';
    import textarea_plus from '../components/textarea_plus.vue'
    import database from "../services/database.js";
    import library from "../services/library.js";
    import users from "../services/users.js";
	import store from "../store";

    var clone = require("clone");

	export default {
        name: "params",
        components: {
            json_schema_editor,
            textarea_plus,
            VueTagsInput,
            draggable,
        },
		data() {
			return {
                params: [],
                optional_params: [],
                val: "",
				tables: [],
                id: uniqueId(""),

                name: "",
                names: "",
                load_name: "",
                type: "",
                version: "1"
			};
        },		
        computed: {
        },
        props: {
            dashboard: {
                default: true
            },
            edit_visible: {
                default: false
            },
            only_visible: {
                default: false
            },
            columns: {
                default: () => []
            },
            type_save: {
                default: ""
            }
        },
        watch: {
			load_name: {
				async handler() {
					if (this.load_name) 
						await this.load_library();
				},
			},
            type_save: {
                immediate: true,
                handler()
                {
                    if (this.type_save)
                    {
                        this.type = "params " + this.type_save;
                        this.set_name();
                    }
                }
            },
			params: {
				deep: true,
				handler() {
					this.$emit("change");
				}
			},
        },
        methods: {
			async set_name()
			{
				var names = await library.getby_production(this.type, null, false, false, false);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].name);
				}
			},
            async save_library()
			{
				var data = this.get_obj();

				await library.save(
					this.name,
					this.version,
					data,
					this.type,
					false,
					{},
					true 
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement effectué",
					type: "success"
				});
			},
			async load_library()
			{
				var data = await library.load(
					this.load_name,
					this.version,
					this.type
				);
                this.name = this.load_name;
                this.set_obj(data);
            },
            update(name, value)
            {
                console.log("update_param")
                for (var i = 0; i < this.params.length; i++)
                {
                    if (this.params[i].name == name)
                    {
                        this.params[i].value = value
                        return;
                    }
                }
                for  (var i = 0; i < this.optional_params.length; i++)
                {
                    if (this.optional_params[i].name == name)
                    {
                        this.optional_params[i].value = value;
                        this.add(i);
                        return
                    }
                }
            },
            new_elem(idx)
            {
                this.params[idx].value.push({value: ""});
            },
            del_elem(idx, idx_elem)
            {
                this.params[idx].value.splice(idx_elem, 1);
            },
            refresh(idx)
            {
                //console.log("refresh");
                this.$emit("get_initial_files", idx);
            },
            filteredItems(idx) {
                return this.params[idx].type.options.filter(i => {
                    return i.text.toLowerCase().indexOf(this.val.toLowerCase()) !== -1;
                });
            },
            get(del = true)
            {
                //console.log("get")
                var params = clone(this.params);

                for (var i = 0; i < params.length; i++)
                {
                    if (params[i].type.type == 'textarea_plus' || params[i].type.type == 'json_schema_editor')
                    {
                        params[i].value = this.$refs["params_" + i][0].get_data();
                    }
                    if (params[i].type.type == 'autocomplete')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push(params[i].value[j].text)
                        }
                        params[i].value = value
                    }
                    if (params[i].type.type == 'draggable' || params[i].type.type == 'draggable_list')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push(params[i].value[j].value)
                        }
                        params[i].value = value
                    }
                    if (params[i].type.datalist_values && params[i].type.datalist_values[params[i].value])
                        params[i].value = params[i].type.datalist_values[params[i].value];

                    if (del)
                    {
                        if (params[i].type.datalist_values)
                            delete params[i].type.datalist_values;
                        if (params[i].type.datalist)
                            delete params[i].type.datalist;
                        if (params[i].type.options)
                            delete params[i].type.options;
                    }
                }

                return params;
            },
            get_obj()
            {
                var params = this.get();
                var obj = {};
                
                for (var i = 0; i < params.length; i++)
                {
                    obj[params[i].name] = params[i].value;
                }

                return obj;
            },
            async set_obj(data)
            {
                //console.log(data)
                //console.log(this.params)
                var self = this;

                for (var i = 0; i < this.params.length; i++)
                {
                    if (data.hasOwnProperty(this.params[i].name));
                    {
                        this.params[i].value = data[this.params[i].name] || this.params[i].default;
                        if ((this.params[i].type.type == 'textarea_plus' || this.params[i].type.type == 'json_schema_editor') && this.$refs["params_" + i])
                            this.$refs["params_" + i][0].load(this.params[i].value);
                        if (this.params[i].type.type == 'autocomplete')
                        {
                            var value = [];
                            for (var j = 0; j < this.params[i].value.length; j++)
                            {
                                value.push({"text": this.params[i].value[j]})
                            }
                            this.params[i].value = value;
                        }
                        if (this.params[i].type.type == 'draggable' || this.params[i].type.type == 'draggable_list')
                        {
                            var value = [];
                            for (var j = 0; j < this.params[i].value.length; j++)
                            {
                                this.value.push({"value": this.params[i].value[j]})
                            }
                            this.params[i].value = value;
                        }
                    }
                }
                for (var i = 0; i < this.optional_params.length; i++)
                {
                    if (data.hasOwnProperty(this.optional_params[i].name) && data[this.optional_params[i].name])
                    {
                        this.optional_params[i].value = data[this.optional_params[i].name];
                        await this.add(i);
                        i--;
                    }
                }

                await this.$nextTick();

                for (var i = 0; i < this.params.length; i++)
                {
                    if ((this.params[i].type.type == 'textarea_plus' || this.params[i].type.type == 'json_schema_editor') && this.$refs["params_" + i])
                        this.$refs["params_" + i][0].load(this.params[i].value);
                }
            },
            async set(params, data, visible_arr = [])
            {
                var self = this;

                if (this.is_set)
                    return;

                this.is_set = true;

                var visible = {};

                for (var i = 0; i < visible_arr.length; i++)
                {
                    visible[visible_arr[i].name] = visible_arr[i].visible || false;
                }

                params = clone(params)

                //console.log("set params")
                //console.log(params)

                this.params = [];
                this.optional_params = [];
                for (var i = 0; i < params.length; i++)
                {
                    if (visible[params[i].name])
                        params[i].visible = true;
                    params[i].value = params[i].default;
                    if (params[i].type.type == 'autocomplete')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push({"text": params[i].value[j]})
                        }
                        params[i].value = value
                    }
                    if (params[i].type.type == 'draggable' || params[i].type.type == 'draggable_list')
                    {
                        var value = [];
                        for (var j = 0; j < params[i].value.length; j++)
                        {
                            value.push({"value": params[i].value[j]})
                        }
                        params[i].value = value;
                    }
                    if (params[i].type.db && params[i].type.db.table)
                    {
                        var params_db = {
                            select: params[i].type.db.value + " AS value, " + params[i].type.db.libelle + ' AS libelle',
                        };
                        if (params[i].type.db.where)
                            params_db.where = params[i].type.db.where;
                        if (params[i].type.db.end)
                            params_db.end = params[i].type.db.end;

                        var results = await database.get("SELECT", params[i].type.db.table, params_db);

                        if (params[i].type.type == "list")
                        {
                            for (var j = 0; j < results.length; j++)
                            {
                                params[i].type.options.push({value: results[j].value, text: results[j].libelle})
                            }
                        }
                        else
                        {
                            params[i].type.datalist_values = {}
                            for (var j = 0; j < results.length; j++)
                            {
                                params[i].type.datalist.push(results[j].libelle);
                                params[i].type.datalist_values[results[j].libelle] = results[j].value;
                            }
                        }
                    }
                    if (params[i].required)
                    {
                        this.params.push(params[i]);
                    }
                    else
                    {
                        this.optional_params.push(params[i]);
                    }
                }

                if (data)
                {
                    this.set_obj(data);
                }

                this.is_set = false;
                //console.log("set params end");

                self.$nextTick(async function () {
                    for (var i = 0; i < params.length; i++)
                    {
                        if (params[i].type.type == 'textarea_plus' || this.params[i].type.type == 'json_schema_editor')
                            self.$refs["params_" + i][0].load(params[i].value);
                    }
                });
            },
            add(idx)
            {
                var self = this;

                this.params.push(this.optional_params[idx]);
                this.optional_params.splice(idx, 1);

                self.$nextTick(async function () {
                    if (self.params[self.params.length - 1].type.type == 'database')
                        self.updateTable(self.params.length - 1);
                });
            },
            del(idx)
            {
                this.optional_params.push(this.params[idx]);
                this.params.splice(idx, 1);
            },
			async updateTable(idx) {
				var self = this;
				this.$refs["params_" + idx][0].init(self.params[idx].type.table);
			}
		},
		mounted: async function () {
            var self = this;
            
			var user = store.state.user;
            var response = await users.getSelf(true);
			this.client = response.client;

		},
	};
</script>

<style scoped>
</style>
